import { gql } from '@apollo/client';

export default gql`
    query loadAvatarQuery($id: ID!) {
        result: workspace(id: $id) {
            id
            name
        }
    }
`;
